import React from "react";
import { TextInput, DateInput } from "../../../components/input_hook_form";
import "./style.scss";
function Benchmark(props) {
  const { register, show, mode, control, errors ,defaultValues, setValue} = props;
  const locked = mode === "VIEW" || mode === "EDIT";
  const editable = (rules) => (locked ? {} : rules);
  return (
    <div className={show ? "benchmark-container" : "benchmark-container-hide"}>
      {locked ? (
        <p className="benchmark-note">
          These values come from the Portal NAV sync and the benchmark CSV
          upload, and cannot be edited here.
        </p>
      ) : null}
      <TextInput
        label={"Country Code"}
        placeholder={"Country Code"}
        error={!locked && errors["benchmark-countrycode"]}
        register={register(editable({ 
            required: true, 
            minLength: 1
        }))}
        type={"text"}
        name="benchmark-countrycode"
        disabled={locked}
      />
      <div className="benchmark-spacer" />
      <TextInput
        label={"Fund Code"}
        placeholder={"Fund Code"}
        error={!locked && errors["benchmark-fundcode"]}
        register={register(editable({
          required: true,
          minLength: 1
        }))}
        type={"text"}
        name="benchmark-fundcode"
        disabled={locked}
      />
      <div className="benchmark-spacer" />
      <TextInput
        label={"Benchmark Code"}
        placeholder={"Benchmark Code"}
        error={!locked && errors["benchmark-benchmarkcode"]}
        register={register(editable({ 
            required: false
        }))}
        type={"text"}
        name="benchmark-benchmarkcode"
        disabled={locked}
      />
      <div className="benchmark-spacer" />
      <TextInput
        label={"Benchmark Name"}
        placeholder={"Benchmark Name"}
        error={!locked && errors["benchmark-benchmarkname"]}
        register={register(editable({ 
            required: false
        }))}
        type={"text"}
        name="benchmark-benchmarkname"
        disabled={locked}
      />
      <div className="benchmark-spacer" />
      <TextInput
        label={"Fund ID"}
        placeholder={"Fund ID"}
        error={!locked && errors["benchmark-fundid"]}
        register={register(editable({ required: true }))}
        type={"number"}
        name="benchmark-fundid"
        disabled={locked}
      />
      <div className="benchmark-spacer" />
      <TextInput
        label={"Benchmark YTD"}
        placeholder={"Benchmark YTD"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="benchmark-benchmarkytd"
        disabled={locked}
      />
      <div className="benchmark-spacer" />
      <TextInput
        label={"Benchmark 03months"}
        placeholder={"Benchmark 03months"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="benchmark-03months"
        disabled={locked}
      />
      <div className="benchmark-spacer" />
      <TextInput
        label={"Benchmark 06months"}
        placeholder={"Benchmark 06months"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="benchmark-06months"
        disabled={locked}
      />
      <div className="benchmark-spacer" />
      <TextInput
        label={"Benchmark 12months"}
        placeholder={"Benchmark 12months"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="benchmark-12months"
        disabled={locked}
      />
      <div className="benchmark-spacer" />
      <TextInput
        label={"Benchmark 03years"}
        placeholder={"Benchmark 03years"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="benchmark-03years"
        disabled={locked}
      />
      <div className="benchmark-spacer" />
      <TextInput
        label={"Benchmark 05years"}
        placeholder={"Benchmark 05years"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="benchmark-05years"
        disabled={locked}
      />
      <div className="benchmark-spacer" />
      <TextInput
        label={"Benchmark 10years"}
        placeholder={"Benchmark 10years"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="benchmark-10years"
        disabled={locked}
      />
      <div className="benchmark-spacer" />
      <TextInput
        label={"Benchmark Since Inception"}
        placeholder={"Benchmark Since Inception"}
        register={register(editable({
          required: false,
          min: -9999999999,
          max: 9999999999
        }))}
        step={0.0001}
        type={"number"}
        name="benchmark-sinceinception"
        disabled={locked}
      />
      <div className="benchmark-spacer" />
      <DateInput
        label={"As of Date (DD-MM-YYYY)"}
        placeholder={"As of Date (DD-MM-YYYY)"}
        control={control}
        setValue={setValue}
        error={!locked && errors["benchmark-asofdate"]}
        rules={{ required: false }}
        name="benchmark-asofdate"
        disabled={locked}
        defaultValues = {defaultValues["benchmark-asofdate"]}

      />
    </div>
  );
}

export default Benchmark;
